export default __webpack_public_path__ + "3962837caa755098bd2da6c998b42a5e.png";